import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchPowerPerformanceRank } from '../repository/MutualFundDetail'
import {
  MetaDataResponse,
  MutualFundDetailSubSections,
  WaterfallSections
} from '../types/mutual-fund-detail.types'
import { getAlternateIsinFromWaterfall } from './useAlternateISIN'

export function usePowerPerformanceRankQuery(params: {
  isin: string
  metadata: MetaDataResponse | undefined
}) {
  const { isin, metadata } = params

  const { alternateISIN } = useMemo(
    () =>
      getAlternateIsinFromWaterfall({
        isin,
        metadata,
        waterfallKey: WaterfallSections.HERO
      }),
    [isin, metadata]
  )

  const isQueryEnabled =
    !!isin &&
    (metadata?.sections?.some((sectionRow) =>
      sectionRow?.subSections?.includes(MutualFundDetailSubSections.POWER_PERFORMANCE)
    ) ??
      false)

  const queryKey = useMemo(() => ['powerPerformanceRank', alternateISIN], [alternateISIN])

  const { data, isLoading, isSuccess, isError } = useQuery<any, Error>({
    queryKey,
    queryFn: () => fetchPowerPerformanceRank(alternateISIN || isin),
    enabled: isQueryEnabled,
    retry: 1,
    refetchOnWindowFocus: false
  })

  return {
    powerPerformanceRankData: data,
    isPowerPerformanceRankLoading: isLoading,
    isPowerPerformanceRankSuccess: isSuccess,
    isPowerPerformanceRankError: isError
  }
}
